import React from 'react';
import Menu from '../Menu';
import Unit from './Unit';
import ResourceCalendar from './ResourceCalendar';
import moment from 'moment';
import './Resource.css';
import TeamChooser from './TeamChooser';
import TimeSelectForm from "./TimeSelectForm";
import { useDispatch, useSelector } from 'react-redux';
import { setToCategoryView, setToUnitView } from '../../store/ResourceStore';



const Resource = () => {
    const dispatch = useDispatch();
    const now = moment();

    const units = useSelector((state) => state.resourceState.units);
    const bookings = useSelector((state) => state.resourceState.bookings);
    
    const categories = useSelector((state) => state.resourceState.categories);

    // group categories so we can render them in three vertical columns
    const grassCategories = categories.filter(c => c && c.trim().startsWith('Græs'));
    const trailerCategories = categories.filter(c => c && c.trim().startsWith('Trailer'));
    const otherCategories = categories.filter(c => c && !c.trim().startsWith('Græs') && !c.trim().startsWith('Trailer'));
    const activeCategory = useSelector((state) => state.resourceState.activeCategory);
    const showCategories = useSelector((state) => state.resourceState.showCategories);

    const bookingsNow = bookings.filter(x => now.isSameOrAfter(x.startTime) && now.isSameOrBefore(x.endTime));

    const futureBookings = bookings.filter(x => now.isBefore(x.startTime))
        .sort((a,b) => {
            a = new Date(a.startTime);
            b = new Date(b.startTime);
            return a < b ? -1 : a > b ? 1 : 0
        });


    return(
        <div className="App">
            <Menu />
            <div className='Resource'>
                <div className='padding-content'>
                    <div className='units-container'>
                        <div className='booking-header-wrapper'>
                        <h2 className='book-header'>Book udstyr</h2>
                        {
                            !showCategories && (<><span className='back-arrow' onClick={() => dispatch(setToCategoryView())}>&#8249;</span><h3 className='back-header' onClick={() => dispatch(setToCategoryView())}> Tilbage til kategorier</h3></>)
                        }
                        </div>
                        <div className={`units ${showCategories ? 'categories-grid' : ''}`}>
                            {
                                showCategories && (
                                    <>
                                        <div className='category-column'>
                                            {otherCategories.map(category => (
                                                <div className='unit-category' key={`category-${category}`} onClick={() => {dispatch(setToUnitView(category))}}>
                                                    {category}
                                                </div>
                                            ))}
                                        </div>
                                        <div className='category-column'>
                                            {grassCategories.map(category => (
                                                <div className='unit-category' key={`category-${category}`} onClick={() => {dispatch(setToUnitView(category))}}>
                                                    {category}
                                                </div>
                                            ))}
                                        </div>
                                        <div className='category-column'>
                                            {trailerCategories.map(category => (
                                                <div className='unit-category' key={`category-${category}`} onClick={() => {dispatch(setToUnitView(category))}}>
                                                    {category}
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )
                            }
                            {
                                units.map((u,i) => {
                                    const nextBooking = futureBookings.find(x => x.unitId === u.id);
                                    const currentBooking = bookingsNow.find(x => x.unitId === u.id);

                                    if(!showCategories && u.category == activeCategory){
                                        return(
                                            <Unit
                                                key={i}
                                                unit={u}
                                                currentBooking={currentBooking}
                                                nextBooking={nextBooking}
                                            />
                                        );
                                    }
                                    return;


                                })
                            }
                        </div>
                        <div className='clearfix'/>
                    </div>
                    <ResourceCalendar />
                </div>
                <TimeSelectForm/>
                <TeamChooser/>
            </div>
        </div>
    )
};

export default Resource;